// import axios from 'axios';
import $ from 'jquery';
// let SITE_HOST = `https://www.geograftour.com`;
const CABINET_HOST = `https://cabinet.geograftour.com`;
// const hostName = window.location.hostname;

// if (hostName === '127.0.0.1' || hostName === 'localhost') {
//   SITE_HOST = `http://127.0.0.1:8000`;
// }

// АПИХА ДЛЯ ПРЕКРАСНОГО САЙТА БУДУЩЕГО АПИХА ДЛЯ ПРЕКРАСНОГО САЙТА БУДУЩЕГО АПИХА ДЛЯ ПРЕКРАСНОГО САЙТА БУДУЩЕГО
// const apiConfig = {
//   url: SITE_HOST,
//   headers: {
//     Accept: 'application/json',
//     'Content-type': 'application/json',
//   },
//   credentials: 'include',
// };

// class Api {
//   constructor({ url, headers, credentials }) {
//     this._url = url;
//     this._headers = headers;
//     this._credentials = credentials;
//   }

//   _getResponse(res) {
//     if (res.geokey) {
//       return res.json();
//     }
//     return Promise.reject(res);
//   }

//   _request(endpoint, options) {
//     return fetch(`${this._url}${endpoint}`, options).then(this._getResponse);
//   }

//   setLike(tourData) {
//     return this._request(`/orders/add-like-api/`, {
//       method: 'GET',
//       headers: this._headers,
//       data: tourData,
//     });
//   }
// }
// export const NewCabinetApi = new Api(apiConfig)
// АПИХА ДЛЯ ПРЕКРАСНОГО САЙТА БУДУЩЕГО АПИХА ДЛЯ ПРЕКРАСНОГО САЙТА БУДУЩЕГО АПИХА ДЛЯ ПРЕКРАСНОГО САЙТА БУДУЩЕГО

const cabinetAPI = {
  async getCart() {
    const url = `${CABINET_HOST}/orders/shop-api/`;
    const result = await $.ajax({
      url: url,
      jsonp: 'callback',
      dataType: 'jsonp',
      data: {
        format: 'json',
      },
    });
    return result;
  },

  async getLikes() {
    const url = `${CABINET_HOST}/orders/like-list/`;
    const result = await $.ajax({
      url: url,
      jsonp: 'callback',
      dataType: 'jsonp',
      data: {
        format: 'json',
      },
    });
    return result;
  },

  async getCarts() {
    const url = `${CABINET_HOST}/orders/cart-list/`;
    const result = await $.ajax({
      url: url,
      jsonp: 'callback',
      dataType: 'jsonp',
      data: {
        format: 'json',
      },
    });
    return result;
  },

  async removeLike(geokey) {
    const url = `${CABINET_HOST}/orders/remove-json-tour/?geokey=${geokey}&like=true`;
    const result = await $.ajax({
      url: url,
      jsonp: 'callback',
      dataType: 'jsonp',
      data: {
        format: 'json',
      },
    });
    return result;
  },

  async removeCart(geokey) {
    const url = `${CABINET_HOST}/orders/remove-json-tour/?geokey=${geokey}&cart=true`;
    const result = await $.ajax({
      url: url,
      jsonp: 'callback',
      dataType: 'jsonp',
      data: {
        format: 'json',
      },
    });
    return result;
  },

  checkLogin(callback) {
    $.ajax({
      url: `${CABINET_HOST}/api/check-login/`,
      dataType: 'json',
      xhrFields: {
        withCredentials: true,
      },
      error: function (jqxhr) {
        console.log('Failed to load resource', jqxhr);
        callback(false);
      },
      success: function (data) {
        callback(data.is_auth);
        // frontend.user_is_logined = data.is_auth;
      },
    });
  },
};

export default cabinetAPI;
